import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../shared/capsFetcher';

const useMerchants = ({ params }, options = {}) => useSWRImmutable({ url: '/dealerships', params }, capsFetcher, options);

export default useMerchants;
